import { createContext, useContext, useEffect, useReducer } from "react";
import { useProductContext } from "./productcontext"; 
import reducer from "../reducer/filter_reducer" 


const FilterContext=createContext()
  export const FilterContextProvider=({children})=>{
     const initialState ={
       filter_products:[],
        all_products:[], 
        grid_view:true, 
        sorting_value:"lowest", 
        filters:{
           text:"", 
           subcategory:"All",
            category:"All", 
            Item:"All" 
          },
          subcategories: [],   // 👈 new
          items: []            // 👈 new

         }; 
  const {products, getFilteredProducts,getSubcategoriesByCategory,getItemsByCategory,getItemsBySubcategory,getAllItems}=useProductContext();
        const [state,dispatch]=useReducer(reducer,initialState); 
        
        //set grid view 
        const setGridView=()=>{ return dispatch({type:"set_grid"}); } 
         //set list view
          const setListView=()=>{ return dispatch({type:"set_list"}); } 
          
        //sorting function 
        // const sorting=(event)=>{ let userValue=event.target.value;
        //  dispatch({type:"get_sort", payload:userValue}); }; 

         const sorting = (sortValue) => {
  // update local state so UI knows which sort is active
  dispatch({ type: "get_sort", payload: sortValue });

  // call backend with filters + sort
  getFilteredProducts({
    category: state.filters.category,
    subcategory: state.filters.subcategory,
    Item: state.filters.Item,
    sort: sortValue
  });
};

  
        //update filters 
        const updateFilterValue=(event)=>{
//         

const { name, value } = event.target;

  // If category is changed, reset subcategory and item
  if (name === "category") {
    dispatch({ type: "update_filter", payload: { name: "subcategory", value: "All" } });
    dispatch({ type: "update_filter", payload: { name: "Item", value: "All" } });

    // 👉 Fetch subcategories for this category
    if (value !== "All") {
      getSubcategoriesByCategory(value);   // call backend to update dropdown list
       // fetch Items for this category
     getItemsByCategory(value);   // 👈 fetch Items for this category


    } else {
      getAllItems(); // reset to all Items

      dispatch({ type: "Set_Subcategories", payload: [] }); // clear subcategories if "All"
    }
  }

  // If subcategory is changed, reset item
  if (name === "subcategory") {
    dispatch({ type: "update_filter", payload: { name: "Item", value: "All" } });

    // 👉 Fetch items for this subcategory
    if (value !== "All") {
      getItemsBySubcategory(value);
    } else {
      // dispatch({ type: "Set_Items", payload: [] });
      getAllItems(); // reset to all Items

    }
  }

  // Apply the user's actual selection
  dispatch({ type: "update_filter", payload: { name, value } });

      // 👉 Call backend filtering with updated filters (including text!)
    const newFilters = {
      ...state.filters,
      [name]: value,
    };
    getFilteredProducts(newFilters);
  




             }; 
             //clear filter 
             const clearFilters = () => {
  dispatch({ type: "clear_filters" });

  // reset dropdowns
  dispatch({ type: "Set_Subcategories", payload: [] });
  dispatch({ type: "Set_Items", payload: [] });

  // fetch all products again with A → Z sort
  getFilteredProducts({
    text: "",
    category: "All",
    subcategory: "All",
    Item: "All",
    sort: "az"
  });

  // reset items list to all
  getAllItems();

  // update local sorting state so reducer knows
  dispatch({ type: "get_sort", payload: "az" });
};
            
             //sorting
              useEffect(()=>{ dispatch({type:"filter_products"}); 
              dispatch({type:"sorting_products"}); },[products,state.sorting_value,state.filters]);
               useEffect(()=>{ dispatch({type:"load_filter_product",payload:products}) },[products]) 
               return (
               <FilterContext.Provider value={{
                ...state,
                setGridView,
                setListView,
                sorting,
                updateFilterValue,
                clearFilters
              }}>
                 {children} 
                 </FilterContext.Provider> 
                 );
             };
            export const useFilterContext=()=>{ return useContext(FilterContext); 
              
            }